/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Personal` - PERSONAL
 * * `AppSumo` - APP_SUMO
 * * `Premium` - PREMIUM
 * * `Business` - BUSINESS
 * * `Enterprise` - ENTERPRISE
 */
export enum Subscription {
  PERSONAL = 'Personal',
  APP_SUMO = 'AppSumo',
  PREMIUM = 'Premium',
  BUSINESS = 'Business',
  ENTERPRISE = 'Enterprise',
}
